import React, { PureComponent } from 'react';

import Spinner, { SpinnerProps } from '@atlaskit/spinner';

import { CenteredRow } from 'src/styles';

type LoadingProps = SpinnerProps & {
  className?: string;
};

export default class Loading extends PureComponent<LoadingProps> {
  render() {
    const { className, testId, ...spinnerProps } = this.props;

    return (
      <CenteredRow className={className}>
        <Spinner
          size="small"
          {...spinnerProps}
          testId={testId || 'diff-loading-spinner'}
        />
      </CenteredRow>
    );
  }
}
